/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import queryString from 'query-string';
import CompanyEquipmentViewerLayer from 'components/layer/CompanyEquipmentViewerLayer';
import { getCompanyById } from 'components/axios/companyAxios';
import { useEnumApi } from 'contexts/EnumApiContext';

const CompanyViewMonitoring = () => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const qs = queryString.parse(window.location.search);
    const searchParam = '?searchField='+(qs?.searchField||'')+'&searchKeyword='+(qs?.searchKeyword||'')+'&searchType='+(qs?.searchType||'')+'&searchStatus='+(qs?.searchStatus||'')
    +'&page='+(qs?.page||'')+'&size='+(qs?.size||'');
    
    const {id} = useParams();
    const [company, setCompany] = useState({});
    const [users, setUsers] = useState([]);
    const [zones, setZones] = useState([]);

    useEffect(()=>{
      // console.log(id)
      if (isNaN(id)) {
        window.location.replace('/company'+searchParam);
        return;
      }

      getCompanyById(id).then((res)=> {
        // console.log(res)
        setCompany(res);
        setUsers(res.users);
        setZones(res.equipmentZones);
      })

    },[id]);

    const onSubmit = (data) => {
      console.log(data)
    }

    const loginOnSubmit = (data) => {
      console.log(data)
    }

    const userOnSubmit = (data) => {
      console.log(data)
    }

    const userUpdateOnSubmit = (data) => {
      console.log(data)
    }

    let linkUrl = '';
    if (company && id) {
      return (
      <div className="sub_container">
        {/* <div>
          <h5 className="mro_m_left" style={{color:"#fff"}}>* 백운</h5>
        </div> */}

        <div className='cal'>
          {/* 기본정보 */}
          <div className="mro_search">
              <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.subtitle.basic.info')}</h6>
          </div>
          <TableContainer>
          <Table aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
              <TableBody>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.type')}</TableCell>
                <TableCell className="view_td2">
                  {getEnumValueByEnumNameAndCode('CompanyType', company.type)?.[0]?.title || ''}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.company.name')}</TableCell>
                <TableCell colSpan={3} className="view_td2">
                  {company.info?.name}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.address')}</TableCell>
                <TableCell colSpan={5} className="view_td2">
                    {company.info?.address}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.company.contact')}</TableCell>
                <TableCell colSpan={3} className="view_td2">
                  {company.info?.contact}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.status')}</TableCell>
                <TableCell className="view_td2">
                  {getEnumValueByEnumNameAndCode('ActiveStatus', company.loginActiveStatus)?.[0]?.title || ''}
                </TableCell>
              </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          
          <br/>
          {/* 사용자 목록 */}
          <div>
            <div className="mro_search">
              <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.title.user.list')}</h6>
            </div>
            <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.authority')}</TableCell>
                      <TableCell className="th" align="center">{t('login.id')}</TableCell>
                      {/* <TableCell className="th" align="center">{t('message.common.subtitle.password')}</TableCell> */}
                      <TableCell className="th" align="center">{t('message.common.subtitle.manager.name')}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.email')}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.company.contact')}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.manager.zone')}</TableCell>
                      <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    { users?.length > 0 && users.map(function(user, i) {
                      return (
                    <TableRow key={i}>
                      <TableCell>{getEnumValueByEnumNameAndCode('RoleType', user.role)?.[0]?.title || ''}</TableCell>
                      <TableCell> {user.loginId || ''}</TableCell>
                      {/* <TableCell>{user.password | ''}</TableCell> */}
                      <TableCell>{user.name || ''}</TableCell>
                      <TableCell>{user.email || ''}</TableCell>
                      <TableCell>{user.contact || ''}</TableCell>
                      <TableCell>
                        {/* {user.zones && user.zones.map((zone, k)=>{
                          if (zone.company?.id === company.id) {
                            return (<React.Fragment key={k}>{zone.name || ''}{k<user.zones.length-1 && <br/>}</React.Fragment>)
                          } else {
                            return (<React.Fragment key={k}>{zone.company.name || ''} &gt; {zone.name || ''}{k<user.zones.length-1 && <br/>}</React.Fragment>)
                          }
                        })} */}
                      </TableCell>
                      <TableCell>{getEnumValueByEnumNameAndCode('ActiveStatus', user.loginActiveStatus)?.[0]?.title || ''}</TableCell>
                    </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
            </TableContainer>
          </div>

          {company.type === 'MAN' &&
          <>
          <br/>
          {/* 구역 목록 */}
          <div>
            <div className="mro_search">
              <h6 className="mro_m_left" style={{color:"#fff"}}>* {t('message.common.title.zone.list')}</h6>
            </div>
            <TableContainer>
                <Table aria-label="simple table">
                  <TableBody>
                    { zones?.length > 0 && zones.map(function(zone, j) {
                      return (
                    <React.Fragment key={j}>
                    <TableRow style={{borderTop:"2px solid"}}>
                      <TableCell className="th" align="center">{t('message.common.subtitle.zone.name')}</TableCell>
                      <TableCell>{zone.name || ''}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th" align="center">{t('message.common.subtitle.address')}</TableCell>
                      <TableCell>{zone.address || ''}</TableCell>
                    </TableRow>
                    <TableRow style={{borderBottom:"2px solid"}}>
                      <TableCell className="th" align="center">{t('message.common.subtitle.zone.image')}</TableCell>
                      <TableCell>
                        {zone.locationMaps?.map((map, mIdx)=>{
                            if (map.file) {
                                const extension = map.file?.originFile.substring(map.file?.originFile.lastIndexOf(".")+1);
                                if (extension.toLowerCase() !== 'svg') {
                            return (
                                <CompanyEquipmentViewerLayer key={mIdx} fileId={map.file?.id} mapsId={map.id} />
                            )
                                } else {
                            return (
                                <img key={mIdx}
                                    src={`${window.RUNTIME_CONFIG.REACT_APP_API_URL}/api/download/${map.file?.id}`}
                                    alt="Thumbnail"
                                    style={{width: "80px" ,height: "80px" ,padding:"3px"}}
                                />
                            )
                                }
                            }
                        })}
                      </TableCell>
                    </TableRow>
                    </React.Fragment>
                      )
                    })}
                  </TableBody>
                </Table>
            </TableContainer>
          </div>
          </>
          }
          <div style={{marginTop:"10px",display: "flex",justifyContent: "space-between",}}>
              <div>
                  <Link to={'/company'+searchParam}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.return')}</Button></Link>
              </div>
          </div>
        </div> 
      </div>
      );
    }
}

export default CompanyViewMonitoring;